import React, { useState } from "react";
import Notification from "../Notification"
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import NotificationsActiveIcon from '@mui/icons-material/HandymanOutlined';
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

function ServiceNotification({ notification, handleClose }) {

    let navigate = useNavigate();
    const { t } = useTranslation();

    const handleNotificationClick = () => {
        if (!notification.repairOrder) return;
        navigate(`/editEntry/${notification.repairOrder.id}`, { replace: true });
        handleClose();
    };

    const getBody = () => {
        let body = "";
        if (notification.repairOrder?.outsourcedFrom) {
            const { outsourcedFrom } = notification.repairOrder;
            let acceptance = notification.type === "SERVICE_ACCEPTED" ? t("accepted a service on") : t("declined a service on");
            body = `${outsourcedFrom.organization.name} ${acceptance} ${notification.repairOrder.brand} ${notification.repairOrder.model}`;
        }
        return body;
    };

    const modifiedTitle = () => {
        let orgId = notification.repairOrder?.organizationId;
        let counter = notification.repairOrder?.organizationCounter;

        let title = notification.type === "SERVICE_ACCEPTED" ? t("Service accepted") : t("Service declined");

        if (notification.repairOrder?.outsourcedFrom) {
            const { outsourcedFrom } = notification.repairOrder;
            orgId = outsourcedFrom.organizationId;
            counter = outsourcedFrom.organizationCounter;
            if (orgId && counter) {
                return <Box component={'span'}>{title} <Box component={'span'} color='primary.main'>{orgId}#{counter}</Box> </Box>;
            }
        } else if (orgId && counter) {
            return <Box component={'span'}>{title} <Box component={'span'} color='primary.main'>{orgId}#{counter}</Box> </Box>;
        }

        return <Box component={'span'}>{title}</Box>;
    };

    return (
        <Notification
            notification={notification}
            id={notification.id}
            isRead={notification.isRead}
            avatar={<Avatar sx={{ bgcolor: notification.type == "SERVICE_ACCEPTED" ? 'accepted.main' : 'red.main' }}><NotificationsActiveIcon /></Avatar>}
            body={getBody()}
            title={modifiedTitle()}
            handleNotificationClick={handleNotificationClick}
        />
    );
}

export default ServiceNotification;